import React from "react";
import AboutSection from "./about/about-section";

export default function About() {
  return <AboutSection />;
}
